import React from "react";

/**
 * A form field's image, rendered the same way everywhere it appears: an info
 * screen's picture, or the thing a question is asking about ("is this plating
 * correct?").
 *
 * `url` is the presigned link the server resolves from the field's stored
 * `image_uuid` on each read. It is absent on surfaces that don't resolve images
 * and null when the file is gone, so callers can pass it straight through — a
 * missing image renders nothing rather than a broken tile.
 */
export default function FormFieldImage({ url, size = "question", className = "" }) {
  if (!url) return null;
  const maxHeight = {
    question: "max-h-56", // above an answer control
    inline: "max-h-48", // a scrolling form or a preview
  }[size];
  return (
    <img
      src={url}
      alt=""
      // Capped height, natural aspect ratio: a scrolling form has no fixed
      // frame to fill, so cropping to one would cut the subject out of a photo
      // the author chose deliberately. The slide player is the exception — it
      // gives images a half-screen pane and covers it (see FormPlayer).
      className={["max-w-full w-auto rounded-xl object-contain", maxHeight, className].join(" ")}
    />
  );
}
